/**
 * @package		Al hirafiyin web app
 * @desc		Page script 
 *
 * @copyright	Copyright (C) 2022 Jaayfer abderrahim, Inc. All rights reserved.
 * @license		see LICENSE.txt
 */
import '../css/craftsmen.css';
import photosBrowser from '../../commons/js/photos-browser';
import craftsmanTools from '../../commons/js/craftsman-tools.js';
import app from '../../app';
import $ from 'jquery';
document.addEventListener("DOMContentLoaded", function () {
  // on select country or city or craft
  app.ui.smartSelect.create({
    el: $('.smart-select-country'),
    openIn: 'sheet',
    closeOnSelect: true,
    searchbar: true,
    on: {
      change: function () {
        $('form.filter-craftsmen').trigger('submit');
      }
    }
  });
  app.ui.smartSelect.create({
    el: $('.smart-select-city'),
    openIn: 'sheet',
    closeOnSelect: true,
    searchbar: true,
    on: {
      change: function (smartSelect) {
        $('form.filter-craftsmen').trigger('submit');
      }
    }
  });
  app.ui.smartSelect.create({
    el: $('.smart-select-craft'),
    openIn: 'sheet',
    closeOnSelect: true,
    searchbar: true,
    on: {
      change: function () {
        $('form.filter-craftsmen').trigger('submit');
      }
    }
  });
  $('.smart-select-craftsman-type select').on('change', function () {
    $(this).closest('form').trigger('submit');
  });
  $('form.filter-craftsmen').on('submit', function () {
    $(this).find('#page-number').val(1);
  });

  // create swipper for crafts list and images
  app.ui.swiper.create('.crafts-swiper', {
    speed: 400,
    centeredSlides: false,
    spaceBetween: 10,
    slidesPerView: 1,
    autoplay: {
      delay: 2250
    }
  });
  app.ui.swiper.create('.images-swiper', {
    speed: 400,
    spaceBetween: 10,
    centeredSlides: true,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination'
    }
  });

  // set photos browser
  photosBrowser.initialize('.init-photo-browser');

  // set actions
  $('.craftsman-profile-card .btn-options').on('click', function (params) {
    const data = JSON.parse(decodeURIComponent(window.atob(decodeURIComponent($(this).closest('.craftsman-profile-card').data('craftsman')))));
    craftsmanTools.getAdditionalActionsSheet(data.id, $(this).closest('.craftsman-profile-card').data('link'));
  });
  $('.craftsman-profile-card .btn-like-craftsman').on('click', function () {
    const data = JSON.parse(decodeURIComponent(window.atob(decodeURIComponent($(this).closest('.craftsman-profile-card').data('craftsman')))));
    craftsmanTools.likeProfile(data.id);
  });
  $('.craftsman-profile-card .btn-infos').on('click', function () {
    const data = JSON.parse(decodeURIComponent(window.atob(decodeURIComponent($(this).closest('.craftsman-profile-card').data('craftsman')))));
    craftsmanTools.openProfile(data.id);
  });
});